<template>
  <div class="mod-user">
    <!-- 搜索栏 -->
    <div class="searchBox" :style="{ opacity: config.isConfigMode ? 0.5 : 1, pointerEvents: config.isConfigMode ? 'none' : 'auto' }">
      <el-form :inline="true" :model="dataForm.paramMap" size="small">
        <el-form-item label="打卡人">
          <el-input v-model="dataForm.paramMap.userKeyword" placeholder="真实姓名/手机号/账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="考勤日期">
          <el-date-picker
              v-model="dataForm.paramMap.times"
              :picker-options="pickerOptions"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>
          <el-button @click="() => this.dataForm.paramMap = {}" type="info">重置</el-button>
          <el-button @click="addV" type="success">添加</el-button>
          <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格栏 -->
    <div class="tableBox"  :style="{ position: 'relative' }">
      <!-- 配置模式 -->
      <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
        <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
        <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
        <el-popover placement="right" width="520" trigger="click">
          <div style="justify-self: center;">
            <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
            <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
            <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
              <i class="el-icon-view el-icon--right" />
            </el-tooltip>
          </div>
          <br/>
          <el-tree :data="config.configDefaultColumn"
                   style="max-height: 200px;overflow-y: auto;"
                   default-expand-all
                   show-checkbox
                   draggable
                   node-key="prop"
                   ref="configTableListTree"
                   @check-change="handleCheckChange"
                   @node-drop="handleDrop"
                   :allow-drag="allowDrag"
                   :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
          </el-tree>
          <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
        </el-popover>
        <br/>
        <br/>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-switch
                  v-model="config.configModeForm.defaultOrNot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'">
              </el-switch>
            </div>
          </el-col>
        </el-row>
      </el-row>


      <el-table :data="dataList"
                ref="tableRef"
                @row-click="rowClick"
                :row-style="selectedHighlight"
                height="72vh"
                size="small"
                v-loading="dataListLoading"
                border
                style="width: 100%;"
                :cell-class-name="getCellClassName">
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 上班打卡时间 -->
            <template v-if="item.prop == 'checkInTime'">
              {{ formattedDateTimeHHmm(scope.row.checkInTime) }}
            </template>
            <!-- 午休前打卡时间 -->
            <template v-else-if="item.prop == 'checkBeforeLunchTime'">
              {{ formattedDateTimeHHmm(scope.row.checkBeforeLunchTime) }}
            </template>
            <!-- 午休后打卡时间 -->
            <template v-else-if="item.prop == 'checkAfterLunchTime'">
              {{ formattedDateTimeHHmm(scope.row.checkAfterLunchTime) }}
            </template>
            <!-- 下班打卡时间 -->
            <template v-else-if="item.prop == 'checkOutTime'">
              {{ formattedDateTimeHHmm(scope.row.checkOutTime) }}
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>

        <af-table-column fixed="right" header-align="left" width="120" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="replacementCard(scope.row)">补卡</el-button>
            <el-button type="text" size="small" @click="deleteHandle(scope.row)">删除</el-button>
          </template>
        </af-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="dataForm.page"
                     :page-sizes="[20, 50, 100]" :page-size="dataForm.size" :total="dataForm.total"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />

    <!-- 添加/补卡 -->
    <el-dialog :title="addRecordsByReplacingTheCard.title" :visible.sync="addRecordsByReplacingTheCard.dialog" width="60%" modal-append-to-body append-to-body :close-on-click-modal="false">
      <el-table :data="addRecordsByReplacingTheCard.user.confirmSelectedUserDate" ref="tableRefV2" size="mini" border height="40vh">
        <el-table-column type="index" align="left" label="序号" fixed="left" width="40" />
        <el-table-column prop="account" label="姓名" align="left" fixed="left" width="70" />
        <el-table-column prop="attendanceDate" label="考勤日期" align="left" width="150">
          <template slot-scope="scope">
            <el-date-picker
                size="mini"
                style="width: 100%"
                v-model="scope.row.attendanceDate"
                type="date"
                placeholder="选择考勤日期日期"
                clearable
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions" />
          </template>
        </el-table-column>
        <el-table-column prop="checkInTime" label="上班打卡" align="left"  width="200">
          <template slot-scope="scope">
            <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="scope.row.checkInTime"
                type="datetime"
                placeholder="选择上班打卡日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss" />
          </template>
        </el-table-column>
        <el-table-column prop="checkBeforeLunchTime" label="午休前打卡" width="200" align="left">
          <template slot-scope="scope">
            <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="scope.row.checkBeforeLunchTime"
                type="datetime"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择午休前打卡日期">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="checkAfterLunchTime" label="午休后打卡" width="200" align="left">
          <template slot-scope="scope">
            <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="scope.row.checkAfterLunchTime"
                type="datetime"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择午休后打卡日期" />
          </template>
        </el-table-column>
        <el-table-column prop="checkOutTime" label="下班打卡" align="left" width="200">
          <template slot-scope="scope">
            <el-date-picker
                style="width: 100%"
                size="mini"
                v-model="scope.row.checkOutTime"
                type="datetime"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择下班打卡日期" />
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="left" width="120">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="1" size="mini" placeholder="请输入内容" maxlength="100" v-model="scope.row.remark" clearable autosize />
          </template>
        </el-table-column>
        <el-table-column fixed="right" header-align="left" width="60" label="操作">
          <template slot-scope="scope">
            <el-button @click="deleteConfirmSelectedUserDate(scope)" type="text" size="mini" :disabled="addRecordsByReplacingTheCard.addOrUpdate">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <br />
      <el-row style="justify-self: center;">
        <el-button type="primary" round @click="selectTheAddedUser" :disabled="addRecordsByReplacingTheCard.addOrUpdate" size="mini">选择用户</el-button>
      </el-row>
      <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="addRecordsByReplacingTheCard.dialog = false">取消</el-button>
            <el-button size="mini" :loading="addRecordsByReplacingTheCard.loading" type="primary" @click="submitUserCard()">提交确定</el-button>
        </span>
    </el-dialog>

    <!-- 候选用户 -->
    <el-dialog title="候选用户" :visible.sync="addRecordsByReplacingTheCard.user.userOpen" width="70%" append-to-body>
      <el-row :gutter="20">
        <div class="searchBox">
          <el-form :inline="true" :model="addRecordsByReplacingTheCard.user.dataForm" @keyup.enter.native="getUserDataList()" size="small">
            <el-form-item label="用户名">
              <el-input v-model="addRecordsByReplacingTheCard.user.dataForm.account" placeholder="模糊查询" clearable></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
              <el-input v-model="addRecordsByReplacingTheCard.user.dataForm.realName" placeholder="模糊查询" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="getUserDataList()">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableBox">
          <el-table :data="addRecordsByReplacingTheCard.user.userList"
                    ref="multipleTableUser"
                    @selection-change="selectionChangeHandleUser"
                    height="50vh"
                    border
                    size="small"
                    v-loading="addRecordsByReplacingTheCard.user.dataListLoading"
                    style="width: 100%;">
            <el-table-column type="selection" width="40" fixed="left" align="center" />
            <el-table-column prop="account" align="center" label="用户名" />
            <el-table-column prop="realName" align="center" label="真实姓名" />
            <el-table-column prop="createTime" align="center" label="创建时间" />
            <el-table-column prop="status" width="60" fixed="right" align="center" label="状态">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 2" size="small" type="danger">禁用</el-tag>
                <el-tag v-else size="small">启用</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="sizeChangeHandleUser"
              @current-change="currentChangeHandleUser"
              :current-page="addRecordsByReplacingTheCard.user.pageIndex"
              :page-sizes="[20, 50, 100]"
              :page-size="addRecordsByReplacingTheCard.user.pageSize"
              :total="addRecordsByReplacingTheCard.user.totalPage"
              layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmSelectedUserDateMethod">确 定</el-button>
        <el-button @click="addRecordsByReplacingTheCard.user.userOpen = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import configTable from '@/components/table'
import * as myJsonClon from "@/utils/myJsonClone";
import {formattedDateTimeHHmm} from "@/utils/common";
import * as myPageColumConfig from "@/utils/pageColumConfig";
export default {
  data() {
    return {
      // -----------------动态表格模式start-----------------
      config: myPageColumConfig.clockIn,
      // -----------------动态表格模式end-----------------


      // 搜索信息
      dataForm: {
        page: 1,
        size: 20,
        total: 0,
        paramMap: {}
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },

      // 表格
      dataList: [],
      getIndex: -1,
      dataListLoading: false,

      // 补卡/添加记录
      addRecordsByReplacingTheCard: {
        addOrUpdate: false,
        title: '',
        dialog: false,
        loading: false,
        data: [],
        user: {
          userOpen: false,
          dataListLoading: false,
          selectedUserDate: [],
          confirmSelectedUserDate: [],
          userList: [],
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          dataForm: {
            account: null,
            realName: null,
            status: 1
          },
        },

      }
    }
  },
  components: {configTable},
  activated() {
    this.initConfigTable();
    this.getDataList()
  },
  computed: {
    dictTypeMap: {
      get() {
        return this.$store.state.common.dictTypeMap
      }
    }
  },
  methods: {
    formattedDateTimeHHmm,
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })

        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    // -----------------动态表格模式end-----------------

    /**
     * 点击表格变色
     * @param row 当前行数据
     * @param rowIndex 当前行号
     * @returns {{"background-color": string}}
     */
    selectedHighlight({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    rowClick(row) {
      this.getIndex = row.index
    },

    /**
     * 每页大小
     * @param val 当前选中页大小
     */
    sizeChangeHandle(val) {
      this.dataForm.size = val
      this.dataForm.page = 1
      this.getDataList()
    },

    /**
     * 当前页
     * @param val 当前选中的页数
     */
    currentChangeHandle(val) {
      this.dataForm.page = val
      this.getDataList()
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true

      if (this.dataForm.paramMap.times) {
        this.dataForm.paramMap.attendanceDateStart = this.dataForm.paramMap.times[0]
        this.dataForm.paramMap.attendanceDateEnd = this.dataForm.paramMap.times[1]
      }

      // 执行
      this.$http({
        url: this.$http.adornUrl('/clockIn/page'),
        method: 'post',
        data: this.dataForm
      }).then(({ data }) => {
        this.dataList = data.records
        this.dataForm.total = data.total
      }).finally(() => {
        this.dataListLoading = false
      })
    },

    // 删除
    deleteHandle(row) {
      this.$confirm('确定进行【删除】操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/clockIn/' + row.id),
          method: 'delete',
        }).then(({ data }) => {
          if (data) {
            this.getDataList();
          }
        }).finally(() => {})
      }).catch(() => { })
    },

    // 打卡/补卡
    replacementCard(row) {
      // 重置
      this.addRecordsByReplacingTheCard = this.$options.data().addRecordsByReplacingTheCard
      this.addRecordsByReplacingTheCard.title = '补卡-' + row.userRealName
      this.addRecordsByReplacingTheCard.addOrUpdate = true

      this.addRecordsByReplacingTheCard.user.confirmSelectedUserDate.push({
        id: row.id,
        account: row.userAccount,
        checkInTime: row.checkInTime,
        checkBeforeLunchTime: row.checkBeforeLunchTime,
        checkAfterLunchTime: row.checkAfterLunchTime,
        checkOutTime: row.checkOutTime,
        attendanceDate: row.attendanceDate,
        remark: row.remark,
      })

      this.addRecordsByReplacingTheCard.dialog = true
    },
    addV() {
      // 重置
      this.addRecordsByReplacingTheCard = this.$options.data().addRecordsByReplacingTheCard
      this.addRecordsByReplacingTheCard.title = '打卡'

      this.addRecordsByReplacingTheCard.dialog = true
    },
    getUserDataList () {
      this.addRecordsByReplacingTheCard.user.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/system/user/findList'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.addRecordsByReplacingTheCard.user.pageIndex,
          'limit': this.addRecordsByReplacingTheCard.user.pageSize,
          'account': this.addRecordsByReplacingTheCard.user.dataForm.account,
          'realName': this.addRecordsByReplacingTheCard.user.dataForm.realName,
          'status': this.addRecordsByReplacingTheCard.user.dataForm.status
        })
      }).then(({ data }) => {
        if (data) {
          this.addRecordsByReplacingTheCard.user.userList = data.list
          this.addRecordsByReplacingTheCard.user.totalPage = data.total
        } else {
          this.addRecordsByReplacingTheCard.user.userList = []
          this.addRecordsByReplacingTheCard.user.totalPage = 0
        }
      }).finally(() => {
        this.addRecordsByReplacingTheCard.user.dataListLoading = false
      })
    },
    selectionChangeHandleUser (val) {
      this.addRecordsByReplacingTheCard.user.selectedUserDate = val
    },
    sizeChangeHandleUser (val) {
      this.addRecordsByReplacingTheCard.user.pageSize = val
      this.addRecordsByReplacingTheCard.user.pageIndex = 1
      this.getUserDataList()
    },
    currentChangeHandleUser (val) {
      this.addRecordsByReplacingTheCard.user.pageIndex = val
      this.getUserDataList()
    },
    selectTheAddedUser() {
      this.addRecordsByReplacingTheCard.user.userOpen = true
      this.getUserDataList()
    },
    confirmSelectedUserDateMethod() {
      let cloneSelectedUserDate = myJsonClon.getClone(this.addRecordsByReplacingTheCard.user.selectedUserDate);
      for (let cloneSelectedUserDateElement of cloneSelectedUserDate) {
        this.addRecordsByReplacingTheCard.user.confirmSelectedUserDate.push({
          sourceId: cloneSelectedUserDateElement.id,
          account: cloneSelectedUserDateElement.account,
        })
      }
      this.addRecordsByReplacingTheCard.user.userOpen = false
    },
    deleteConfirmSelectedUserDate(scop) {
      this.addRecordsByReplacingTheCard.user.confirmSelectedUserDate.splice(scop.$index, 1)
    },
    submitUserCard() {
      if (this.addRecordsByReplacingTheCard.user.confirmSelectedUserDate.length <= 0) {
        this.$message.error('请选择用户');
        return
      }
      for (let confirmSelectedUserDateElement of this.addRecordsByReplacingTheCard.user.confirmSelectedUserDate) {
        if (!confirmSelectedUserDateElement.attendanceDate) {
          this.$message.error(confirmSelectedUserDateElement.account + '->考勤日期不能为空');
          return
        }
      }

      this.addRecordsByReplacingTheCard.loading = true
      this.$http({
        url: this.$http.adornUrl(this.addRecordsByReplacingTheCard.addOrUpdate ? '/clockIn/replacementCard' : '/clockIn/add'),
        method: this.addRecordsByReplacingTheCard.addOrUpdate ? 'PUT' : 'POST',
        data: this.addRecordsByReplacingTheCard.addOrUpdate ? this.addRecordsByReplacingTheCard.user.confirmSelectedUserDate[0] : {tmsClockInTables: this.addRecordsByReplacingTheCard.user.confirmSelectedUserDate}
      }).then(({ data }) => {
        this.addRecordsByReplacingTheCard.dialog = false
        this.getDataList()
      }).finally(() => {
        this.addRecordsByReplacingTheCard.loading = false
      })
    }
  }
}
</script>
<style lang="less">
.separatorVV {
  border-top: 2px solid rgba(0, 0, 0, 0.34);
  margin: 10px 0;
}
</style>
